(() => {
  const ENTER_COMPACT_Y = 120; // aşağı inerken compact'a geç
  const TOP_SHOW_Y = 10;       // en üste yaklaşınca expanded'a dön

  let lastY = window.scrollY || 0;
  let mode = 'expanded';
  let ticking = false;

  const setMode = (next) => {
    if (mode === next) return;
    mode = next;
    document.body.classList.toggle('hdr-compact', next === 'compact');
    document.body.classList.toggle('hdr-expanded', next === 'expanded');
  };

  document.body.classList.add('hdr-expanded');

  const onScroll = () => {
    const y = window.scrollY || 0;

    // Aşağı inince compact
    if (y > ENTER_COMPACT_Y) {
      setMode('compact');
    }

    // En üste gelince expanded
    if (y <= TOP_SHOW_Y) {
      setMode('expanded');
    }

    lastY = y;
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      onScroll();
      ticking = false;
    });
  }, { passive: true });
})();